import { wifiOnlySetting } from './network';
import { useNetworkStatus as useNetworkStatusBase } from '@otuvy/ionic-react-common';
import { getFlag } from '../../utils/environmentUtils';
import { EnvironmentConfig } from '../../utils/environmentUtils';

/**
 * WARNING: Be careful using this hook to check the current network status!
 * This hook takes a moment to check if the network is connected.
 * In the meantime, it shows as connected, even if it's not.
 *
 * This hook is mostly useful for things that need to change when the network status changes (e.g. the offline banner).
 * If you want to check current network status, use the isPermittedNetworkConnected function instead.
 */
const useNetworkStatus = () => {
  const { isOnline } = useNetworkStatusBase({
    serverSyncEnabled: getFlag(EnvironmentConfig.SERVER_SYNC),
    wifiOnlySetting,
  });

  return {
    isOnline,
  };
};

export default useNetworkStatus;
